import { render, staticRenderFns } from "./commandList.vue?vue&type=template&id=2cb128ca&scoped=true"
import script from "./commandList.vue?vue&type=script&lang=js"
export * from "./commandList.vue?vue&type=script&lang=js"
import style0 from "./commandList.vue?vue&type=style&index=0&id=2cb128ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb128ca",
  null
  
)

export default component.exports